'use strict';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { lang, tr } from '../../utils/helpers';

const appAccessCode = {
  settings: {
    $formSignIn: $('.js-form-signin'),
    $optionsBlock: $('#options-block'),
    $inputAccessCode: $('#accesscode'),
    $btnAccessCode: $('.js-access-code'),
    $resendCode: $('.js-resend-code'),
    $changeType: $('.js-change-type'),
    $post: {
      email: $('input[name="email"]').val(),
      _token: $('meta[name="csrf-token"]').attr('content'),
    },
  },

  validateCaptcha() {
    return grecaptcha.getResponse().length > 0;
  },

  changeType(el, resetForm = false) {
    const type = $(el).attr('data-type');
    const url = `/entrar/codigo-de-acesso/${type}`;

    $(`.is-${type}`).removeClass('u-display--none');
    $(`.is-${type === 'email' ? 'sms' : 'email'}`).addClass('u-display--none');
    this.handleSubmit(url, resetForm);
  },

  handleSubmit(url, resetForm = false) {
    const s = this.settings;
    const $form = s.$formSignIn;

    if (resetForm) {
      $form.addClass('no-code');
      s.$inputAccessCode.prop('required', false);
    }

    if ($form.hasClass('no-code')) {
      $.ajax({
        type: 'POST',
        url,
        data: s.$post,
        dataType: 'json',
        success: data => {
          if (data.success) {
            $form.removeClass('no-code');
            s.$inputAccessCode.prop('required', true);
            grecaptcha.reset();
            Swal.fire(data.title, data.message, 'success');
          } else {
            Swal.fire(data.title, data.message, 'error');
          }
        },
        error: (xhr, status, error) => {
          console.error('AJAX request failed:', status, error);
          Swal.fire(tr[lang].modal_error_request, '', 'error');
        },
      });
    } else {
      if (!this.validateCaptcha()) {
        console.log('Captcha not validated');
        Swal.fire(tr[lang].modal_error_captcha, '', 'error');
        return;
      }

      $form[0].submit();
    }
  },

  bindActions() {
    const s = this.settings;

    s.$btnAccessCode.on('click', e => {
      e.preventDefault();

      s.$optionsBlock.addClass('u-display--none');
      $('#send-block').removeClass('u-display--none');
      this.changeType(e.currentTarget);
    });

    s.$formSignIn.on('submit', e => {
      e.preventDefault();

      const actionUrl = s.$formSignIn.attr('action');
      this.handleSubmit(actionUrl);
    });

    s.$resendCode.on('click', e => {
      e.preventDefault();
      this.changeType(e.currentTarget, true);
    });

    s.$changeType.on('click', e => {
      e.preventDefault();
      this.changeType(e.currentTarget, true);
    });
  },

  init() {
    this.bindActions();
  },
};

export default appAccessCode;
